module.exports = __webpack_public_path__ + "img/33.e299cf00.jpg";